import { callMethod, resetMethod, sendMethod } from '../../redux/actions';
import {getContracts}  from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/state';
import {  ContractMetaData, ContractTypes } from '../../_shared/constants';
import { useCallback, useEffect, useState } from 'react';
import { ProjectNamespace } from '../../_shared/namespaces/project';
import { AcceptedToken, SacrificeWithBonusType } from '../../_shared/utils/type';
import { getSacContractMetaData, getSacContractTitle, sacToken } from '../../_shared';



interface UseSacProxyProps {
  address?: string | undefined;
  key?: string;
  provider?: any;
  project: ProjectNamespace.Project | null
  // projectContractVersion?: number;
  
}

interface SacrificeOptions {

    onFinish? : (data?: any) => void,
    onError? : (data?: any) => void,
    value? : string,
  
}
export type SacProxy = {
  initialized: boolean;
  getSacrificeContractAddress: (projectId: string, version: number) => void;
  getProjectOwners: (projectId: string) => void;
  getSacrificeFee: () => void;
  getDollarValue: (address: string, amount: string, onFinish?: (data:any)=>void) => void;
  getSacrificePhaseDay: () => void;
  getPointRate: () => void;
  getPointRateForDay: () => void;
  getAcceptedTokens: (addr: string) => void;
  getProjectInfo: () => any;
  getDollarAndPointsAmount: (token: string, amount: string, sacAddress: string, onFinish?: (data:any)=>void) => void
  deploySacrifice: (project?: ProjectNamespace.Project, options?:SacrificeOptions)=>void
  setAcceptedTokens: (address: string[], flag: boolean, options?:SacrificeOptions)=>void
  getCalculatePointToken: (amountInWeigh: string, tokenAddress:string, onFinish?: (data:any)=>void)=>void
  getSacrificeToken: (amount: string,referalAddress: string, tokenAddress:string)=>void
  getWithdraw: (tokenAddress:string, options: SacrificeOptions)=>void
  
  initTokenContract: (tokenAddress:string)=>void
  getSacrificeWithBonus: (data: SacrificeWithBonusType, options?:SacrificeOptions)=>void
  getAllowance: (options: SacrificeOptions)=>void
  getBalanceOf: (options: SacrificeOptions)=>void
  sendApprove: (amount:string ,options: SacrificeOptions)=>void
  resetStoreData:(options?:SacrificeOptions)=>void 
  getUserInfo:(options?:SacrificeOptions)=>void 
  addBonus:(addresses: string[], points: string,options?:SacrificeOptions)=>void 
  cancelAdminBonus:(address: string, bonusId: string,options?:SacrificeOptions)=>void 
  getUsdDecimals: () => void
  loadingDeploy: boolean,
  loadingIfDeployed: boolean,
  loadingAddress: boolean,
  loadingAddToken: boolean,
  loadindDollarValue: boolean,
  loadingCalculatePointToken: boolean,
  address?: string,
  projectOwners?: string,
  acceptedTokens?: AcceptedToken[]
  totalSacUSD?: string,
  dollarValue?: string,
  sacrificePhaseDay?: string,
  pointRate?: string,
  calculatePointToken?: string,
  fees?: {
    currentFeeFlat: string,
    currentFeePercentx100: string,
  },
  sacrificeToken?:any
  sacrificeWithBonus?:any
  usdDecimals: string;
  // setProject: (v: ProjectNamespace.Project)=>void;
  currentSacProxy: any;
  currentSacContract: string;
};

export const useSacProxy = (props: UseSacProxyProps): SacProxy => {
  const dispatch = useDispatch();
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [loadingDeploy, setLoadingDeploy] = useState(false);
  const [loadingAddToken, setLoadingAddToken] = useState(false);
  const [loadingIfDeployed, setLoadingIfDeployed] = useState(false);
  const [loadindDollarValue, setLoadindDollarValue] = useState(false);
  const [loadingCalculatePointToken, setLoadingCalculatePointToken] = useState(false);
  const { address, provider, project } = props;
  const { contract: { data, contracts } = {} } = useSelector(({ contract }: RootState) => ({
    contract,
  }));
  
  const [currentContract, setCurrentContract] = useState<any>();
  const [currentSacProxy, setCurrentSacProxy] = useState(`SacProxyV1`);
  
  const currentProxy = ContractMetaData.find((d: any)=>d.title===currentSacProxy);

  useEffect(()=> {
    
    const contract = getSacContractMetaData(project?.contractVersion);
    console.log('CONTRACVERSIONOO', project, project?.id, contract.title, project?.contractVersion)
    setCurrentContract(contract);
    setCurrentSacProxy(`SacProxyV${contract?.sacProxyVersion ?? 1}`);
    //setCurrentSacContract(contract.title);
    console.log('CURRENTSACCONTRACT', contract);
  }, [project?.id, project?.projectAddress, project?.active, project?.banner, project?.proxyAddress, project?.contractVersion]);
  const currentSacContract = getSacContractTitle(project);
  const initialized = !!Object.keys(contracts??{}).length;
  const fees = data?.[currentSacProxy]?.fees??undefined;
  const sacAddress = data?.[currentSacProxy]?.getSacrificeContractAddress??undefined;
  const projectOwners = data?.[currentSacProxy]?.projectOwners??undefined;
  const dollarValue = data?.[currentSacProxy]?.dollarValue??undefined;
  const acceptedTokens = data?.[currentSacProxy]?.getAcceptedTokens??undefined;
  const sacrificeWithBonus = data?.[currentSacProxy]?.sacrificeWithBonus??undefined;
  const usdDecimals = data?.[currentSacProxy]?.usdDecimals??undefined;
  const totalSacUSD = data?.[currentSacContract]?.projectInfo?.totalContributed??undefined;
  const sacrificePhaseDay = data?.[currentSacContract]?.getSacrificePhaseDay??undefined;
  const pointRate = data?.[currentSacContract]?.getPointRate??undefined;
  const calculatePointToken = data?.[currentSacContract]?.calculatePointToken??undefined;
  const sacrificeToken = data?.[currentSacContract]?.sacrificeToken??undefined;
 
  

  useEffect(() => {
    if(currentSacProxy && provider){
      dispatch(getContracts(provider, [{...currentProxy, address: String(project?.proxyAddress) } ]));  
    }
  }, [currentProxy, provider]);
  
  useEffect(() => {
  
    if (project?.projectAddress) {
      dispatch(getContracts(provider, [{...currentProxy, address: String(project?.proxyAddress) }, {
          ...currentContract,
          address: project?.projectAddress,
        }
      ]));  
    }
  }, [currentContract?.title, project?.projectAddress]);


  const getSacrificeContractAddress =  async (projectId: string, version: number) => {
    setLoadingAddress(true)
    dispatch(
      callMethod(
          currentSacProxy,
          'getSacrificeContractAddress',
          [projectId, `${version}`],
          {
              onFinish: () => {
                  setLoadingAddress(false)
              },
              onError: () => {
                setLoadingAddress(false)
            },
          }
      )
  );
      

    
  };

  const getProjectOwners =  async (projectId: string) => {
    setLoadingIfDeployed(true)
    dispatch(
      callMethod(
          currentSacProxy,
          'projectOwners',
          [projectId],
          {
              onFinish: () => {
                  setLoadingIfDeployed(false)
              },
              onError: () => {
                setLoadingIfDeployed(false)
            },
          }
      )
  );
  };

  const getSacrificeFee =  async () => {
    dispatch(
      callMethod(
          currentSacProxy,
          'fees',
          []
      )
  );
  };
  

  const getUsdDecimals =  async () => {
    dispatch(
      callMethod(
          currentSacProxy,
          'usdDecimals',
          []
      )
  );
  };

  const getDollarValue =  async (address: string, amount: string, onFinish?: (data:any)=>void) => {
    setLoadindDollarValue(true)
    dispatch(
      callMethod(
          currentSacProxy,
          'dollarValue',
          [address, amount],
          {
            onFinish: (d:any) => {
              setLoadindDollarValue(false);
              onFinish?.(d)
            },
            onError: (e: any) => {
              setLoadindDollarValue(false)
            },
          }
      )
  );    
  };

  const getDollarAndPointsAmount =  async (token: string, amount: string, sacAddress: string,  onFinish?: (data:any)=>void) => {
    setLoadindDollarValue(true)
    dispatch(
      callMethod(
          currentSacProxy,
          'getDollarPointsAmounts',
          [token, amount, sacAddress],
          {
            onFinish: (d:any) => {
              setLoadindDollarValue(false);
              onFinish?.(d)
            },
            onError: (e: any) => {
              setLoadindDollarValue(false)
            },
          }
      )
  );    
  };


  const getAcceptedTokens =  useCallback(async (_address: string) => {
    console.log('currentSacContractx2', project?.id, currentSacContract)
    dispatch(
        callMethod(
            currentSacProxy,
            'getAcceptedTokens',
            [_address]
        )
    );
  }, [ currentSacProxy]);
  
  const setAcceptedTokensEvent = (addressParam: string[], flag: boolean = true, options?:SacrificeOptions) => {
    console.log('currentSacContractx--->', project?.id, currentSacContract)
    dispatch(
      sendMethod(
        currentSacContract,
        'setAcceptedTokens',
        [addressParam, flag],
        [
          {
            from: address
          },
        ],
        {
          onFinish: () => {
            setLoadingAddToken(false)
            options?.onFinish?.()
          },
          onError: (e: any) => {
            console.log(`onError`, e)
            setLoadingAddToken(false)
            options?.onError?.()
          },
        }
      )
    );
  }

  const setAcceptedTokens =  (addressParam: string[], flag: boolean = true, options?:SacrificeOptions) => {
    setLoadingAddToken(true)
    setAcceptedTokensEvent(addressParam, flag, options );
  };

  const deploySacrifice = (project?: ProjectNamespace.Project, options?:SacrificeOptions) => {
    const { referralBonusPercent:referalPercent, startDayTime:startDate, 
          minContributionAmount:minimumSacAmount, 
          uplineMustBeSacrificer:memberOnlyUpline,
          user: projectOwner,
          id: projectId,
          phases,
          vestingSchedule: claimPlan,
          contractVersion: version,
          signature
         } = project || {};
    setLoadingDeploy(true)
    const args = [{
      referalPercent : Number(referalPercent) * 100 ,
      refereePercent : Number(referalPercent) * 100 ,
      startDate,
      minimumSacAmount: minimumSacAmount??1,
      memberOnlyUpline: !!memberOnlyUpline,
      projectOwner,
      projectId: `${projectId}`,
      phases,
      version: `${version}`,
      claimPlan: claimPlan?.map(data=>{
        return {...data, percentage: Number(data.percentage) * 100 }
      })??[],
      acceptedTokens: []
    }, signature]
    console.log({ args, fee: fees?.currentFeeFlat, address })
    dispatch(
      sendMethod(
        currentSacProxy,
        'deploySacrifice',
        [...args],
        [
          {
            from: address,
            value: fees?.currentFeeFlat??"0"
          },
        ],
        {
          estimateGas: true,
          onFinish: () => {
            setLoadingDeploy(false)
            options?.onFinish?.()
          },
          onError: (e: any) => {
            console.log(`onError`, e)
            setLoadingDeploy(false)
            options?.onError?.()
          },
        }
      )
    );
      
  };

  const getProjectInfo =  async () => {
    dispatch(
        callMethod(
           currentSacContract,
            'sacProjectInfo',
            []
            
        )
    );
  };


  // const getTotalSacUSD =  async () => {
  //   dispatch(
  //       callMethod(
  //          currentSacContract,
  //           'totalSacUSD',
  //           []
            
  //       )
  //   );
  // };

  const getSacrificePhaseDay =  async () => {
    dispatch(
        callMethod(
           currentSacContract,
            'getSacrificePhaseDay',
            [],
        )
    );
  };

  const getPointRate =  async () => {
    dispatch(
        callMethod(
           currentSacContract,
            'getPointRate',
            [],
        )
    );
  };

  const getPointRateForDay =  useCallback(async ()=>{
    dispatch(
      callMethod(
         currentSacContract,
          'getPointRateForDay',
          [sacrificePhaseDay],
      )
  );
  }, [sacrificePhaseDay]);


  const getCalculatePointToken =  useCallback(async (amountInWeigh: string, tokenAddress:string, onFinish?: (data:any)=>void)=>{
    console.log('calcPoints', amountInWeigh);
    setLoadingCalculatePointToken(true)
    dispatch(
      callMethod(
         currentSacContract,
          'calculatePointToken',
          [amountInWeigh, sacrificePhaseDay, tokenAddress],
          {
            onFinish: (d:any) => {
              setLoadingCalculatePointToken(false)
              onFinish?.(d)
            },
            onError: (e: any) => {
              setLoadingCalculatePointToken(false)
            },
          }
      )
  );
  }, [sacrificePhaseDay]);

  const getUserInfo =  useCallback((options:SacrificeOptions)=>{
    
    dispatch(
      callMethod(
         currentSacContract,
          'userInfo',
          [address],
          {
            onFinish: (data) => {
              options?.onFinish?.(data)
            },
            onError: (e: any) => {
              console.log(`onError`, e)
              options?.onError?.()
            },
          }
      )
  );
  }, [address, currentSacContract]);


  const getWithdraw =  useCallback((tokenAddress:string, options:SacrificeOptions)=>{
    
    dispatch(
      sendMethod(
       currentSacContract,
        'withdraw',
        [tokenAddress],
        [
          {
            from: address
          },
        ],
        {
          onFinish: () => {
            options?.onFinish?.()
          },
          onError: (e: any) => {
            console.log(`onError`, e)
            options?.onError?.()
          },
        }
      )
  );
  }, [address, currentSacContract]);


  const getSacrificeToken =  (amount: string,referalAddress: string, tokenAddress:string)=>{
    dispatch(
      callMethod(
         currentSacContract,
          'sacrificeToken',
          [amount, referalAddress, tokenAddress],
        )
    );
  };
  
  const addBonus =  useCallback(( addresses: string[], points: string,options:SacrificeOptions)=>{
    console.log('CURRENSAC', currentSacContract)
    dispatch(
      sendMethod(
       currentSacContract,
        'addAdminBonus',
        [addresses, points],
        [
          {
            from: address
          },
        ],
        {
          onFinish: () => {
            options?.onFinish?.()
          },
          onError: (e: any) => {
            console.log(`onError`, e)
            options?.onError?.()
          },
        }
      )
    );
    
  }, [address, currentSacContract]);


  const cancelAdminBonus =  useCallback(( _address: string, bonusId: string, options:SacrificeOptions)=>{
    dispatch(
      sendMethod(
       currentSacContract,
        'cancelAdminBonus',
        [_address, bonusId],
        [
          {
            from: address
          },
        ],
        {
          onFinish: () => {
            options?.onFinish?.()
          },
          onError: (e: any) => {
            console.log(`onError`, e)
            options?.onError?.()
          },
        }
      )
    );
    
  }, [address, currentSacContract]);

  const initTokenContract =  ( tokenAddress:string)=>{
    dispatch(getContracts(provider, [
      {...currentProxy,
        address: String(project?.proxyAddress)
      },
      {
        ...currentContract,
        address: project?.projectAddress,
      },
       {
        title: 'SacToken',
        abi: sacToken,
        address: tokenAddress,
      },
      ContractMetaData[3]
  ])); 
  };




  const getSacrificeWithBonus =  (data: SacrificeWithBonusType, options?:SacrificeOptions)=>{
    const sendArgs: any = {
      from: address
    };
    if (options?.value) {
      sendArgs.value = options.value
    }
    dispatch(
      sendMethod(
        currentSacProxy,
        'sacrificeWithBonus',
        [sacAddress, data._amount, data._referalAddress, data._token, data._bonus, data._signature],
          [
            sendArgs,
          ],
          {
            onFinish: () => {
              options?.onFinish?.()
            },
            onError: (e: any) => {
              console.log(`onError`, e)
              options?.onError?.()
            },
          }
        )
    );
  };
  
  const getAllowance =  useCallback(( options:SacrificeOptions)=>{
    dispatch(
      callMethod(
          ContractTypes.sacToken,
          'allowance',
          [address, project?.projectAddress],
          {
            onFinish: (data:any) => {
              options?.onFinish?.(data)
            },
            onError: (e: any) => {
              console.log(`onError`, e)
              options?.onError?.()
            },
          }
        )
    );
  }, [address, project?.projectAddress]);

  const getBalanceOf =  useCallback(( options:SacrificeOptions)=>{
    dispatch(
      callMethod(
          ContractTypes.sacToken,
          'balanceOf',
          [address],
          {
            onFinish: (data:any) => {
              options?.onFinish?.(data)
            },
            onError: (e: any) => {
              console.log(`onError`, e)
              options?.onError?.()
            },
          }
        )
    );
  }, [address]);


  const sendApprove =  useCallback((amount: string, options:SacrificeOptions)=>{
    dispatch(
      sendMethod(
        ContractTypes.sacToken,
        'approve',
        [sacAddress, amount],
        [
          {
            from: address
          },
        ],
        {
          onFinish: () => {
            options?.onFinish?.()
          },
          onError: (e: any) => {
            console.log(`onError`, e)
            options?.onError?.()
          },
        }
      )
    );
  }, [address, sacAddress]);


  const resetStoreData =  async (options:SacrificeOptions) => {
    setLoadingIfDeployed(true)
    dispatch(
      resetMethod(
          currentSacProxy,
          'projectOwners',
          [],
          {
            onFinish: () => {
              setLoadingAddToken(false)
              options?.onFinish?.()
            },
          }
      )
  );
      

    
  };
  

  return {
    getSacrificeContractAddress,
    deploySacrifice,
    getSacrificeFee,
    getDollarValue,
    getProjectOwners,
    getAcceptedTokens,
    setAcceptedTokens,
    getProjectInfo,
    getSacrificePhaseDay,
    getPointRate,
    getPointRateForDay,
    getCalculatePointToken,
    getSacrificeToken,
    getSacrificeWithBonus,
    initTokenContract,
    getAllowance,
    getBalanceOf,
    sendApprove,
    resetStoreData,
    addBonus,
    cancelAdminBonus,
    getUserInfo,
    getWithdraw,
    getDollarAndPointsAmount,
    getUsdDecimals,
    loadingDeploy,
    loadingIfDeployed,
    loadingAddress,
    loadingAddToken,
    loadindDollarValue,
    loadingCalculatePointToken,
    dollarValue,
    pointRate,
    fees,
    address:sacAddress,
    projectOwners,
    acceptedTokens,
    totalSacUSD,
    sacrificePhaseDay,
    calculatePointToken,
    sacrificeToken,
    sacrificeWithBonus,
    usdDecimals,
    initialized,
    currentSacProxy,
    currentSacContract,
  } as SacProxy;
};
